/* Cookie banner on the Shopify Customer Privacy API.
   Shows only where Shopify asks for consent (shouldShowBanner), never tracks by itself,
   and writes the choice with setTrackingConsent. "Cookie settings" in the footer reopens it.
   Add ?cookie_banner=1 to a URL to preview the banner outside the UK. */
(function () {
  var root = document.querySelector('[data-cookie-banner]');
  if (!root) return;
  var intro = root.querySelector('[data-ck-view="intro"]');
  var prefs = root.querySelector('[data-ck-view="prefs"]');
  var boxes = {
    analytics: root.querySelector('[data-ck-box="analytics"]'),
    marketing: root.querySelector('[data-ck-box="marketing"]'),
    preferences: root.querySelector('[data-ck-box="preferences"]')
  };
  var decided = false;
  var lastFocus = null;
  var forced = /[?&]cookie_banner=1(&|$)/.test(window.location.search);

  function api() { return window.Shopify && window.Shopify.customerPrivacy; }

  function current() {
    var p = api();
    try { return (p && p.currentVisitorConsent && p.currentVisitorConsent()) || {}; } catch (e) { return {}; }
  }

  function showIntro() {
    root.hidden = false;
    root.classList.remove('ck--prefs');
    intro.hidden = false;
    prefs.hidden = true;
  }

  function showPrefs(from) {
    var c = current();
    Object.keys(boxes).forEach(function (k) { boxes[k].checked = c[k] === 'yes'; });
    lastFocus = from || document.activeElement;
    root.hidden = false;
    root.classList.add('ck--prefs');
    intro.hidden = true;
    prefs.hidden = false;
    var title = prefs.querySelector('#CkPrefsTitle');
    if (title) title.focus();
  }

  function hide() {
    root.hidden = true;
    root.classList.remove('ck--prefs');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  function save(analytics, marketing, preferences) {
    var p = api();
    if (!p) return;
    var consent = { analytics: analytics, marketing: marketing, preferences: preferences, sale_of_data: marketing };
    decided = true;
    p.setTrackingConsent(consent, function () {
      document.dispatchEvent(new CustomEvent('ew:consent', { detail: consent }));
    });
    hide();
  }

  function closePrefs() {
    if (decided) { hide(); } else { showIntro(); }
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) { if (e.target === root && root.classList.contains('ck--prefs')) closePrefs(); return; }
    if (t.hasAttribute('data-ck-accept')) save(true, true, true);
    else if (t.hasAttribute('data-ck-reject')) save(false, false, false);
    else if (t.hasAttribute('data-ck-save')) save(boxes.analytics.checked, boxes.marketing.checked, boxes.preferences.checked);
    else if (t.hasAttribute('data-ck-manage')) showPrefs(t);
    else if (t.hasAttribute('data-ck-close')) closePrefs();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden && root.classList.contains('ck--prefs')) closePrefs();
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cookie-settings]');
    if (!t) return;
    e.preventDefault();
    if (api()) showPrefs(t);
  });

  function init() {
    var p = api();
    var needs = false;
    try { needs = !!(p.shouldShowBanner && p.shouldShowBanner()); } catch (e) {}
    var c = current();
    var unset = !(c.analytics === 'yes' || c.analytics === 'no');
    var region = '';
    try { region = String((p.getRegion && p.getRegion()) || ''); } catch (e) {}
    decided = !needs && !unset;
    if (needs || (/^GB/.test(region) && unset) || (forced && !decided)) showIntro();
  }

  var tries = 0, loading = false;
  function boot() {
    if (api()) { init(); return; }
    if (!loading && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        loading = false;
        if (!err && api()) init();
      });
    }
    if (!api() && tries++ < 40) setTimeout(boot, 250);
  }
  boot();
})();
